import UserSettingsFtue from "./ftue";

const debug = false
// const debug = "UserClientData"

export default class UserClientData {

    static normalize(data:any) {

        debug && console.log(debug, "NORMALIZE User CLIENT DATA", data)

        data = UserClientData.fix_v421(data)


        const result = {
            setupDone: false,
            labs: {
                navigation: {
                    projectGoToRecentView: true,
                    viewProjectMenuCompact: false,
                },
                interfaceLanguage: _.get(data,'labs.interfaceLanguage','en'),
            },
            presets: {
                myTasks: _.get(data,'presets.myTasks', {})
            },

            notifications: {
                chat: {
                    growl: _.get(data, 'notifications.chat.growl', true),
                    sound: _.get(data, 'notifications.chat.sound', false)
                }
            },

            color:              _.get(data,'color',21), // voobche ne ponyatno chto eto i zachem - nashel ispol'zovanie default project color strannii case
            skin                : _.get(data, 'skin' ),

            momentUpdatesRead:  _.get(data, 'momentUpdatesRead', null), // news ?
            rateExperience:     _.get(data, 'rateExperience', false),       // contains moment when we want to ask for ratings

            ftue: UserSettingsFtue.normalize(data.ftue),

            viewTemplates: _.get(data, 'viewTemplates', []),
            todoLists: _.get(data, 'todoLists', []),

            menu        : _.get(data, 'menu', {}),
            navigation  : _.get(data, 'navigation', {}),
            views       : _.get(data,'views',{}),
            debug       : _.get(data,'debug',{}),
            quickSearch : _.get(data,'quickSearch',{}),
            interface   : _.get(data,'interface',{}),

            // one node per company id - see UserSettings_Company
            company     : _.get(data,'company',{}),

            desktopApp  : _.get(data,'desktopApp',{}),
        };

        // these are the very default values
        // if (!result.layout) result.layout = 'left-nav';
        // if (!result.skin) result.skin = 'violet';

        if (data) {
            if (data.setupDone) result.setupDone = data.setupDone;
            if (data.labs) {
                result.labs.navigation.projectGoToRecentView = _.get(data, 'labs.navigation.projectGoToRecentView', true)
                result.labs.navigation.viewProjectMenuCompact = _.get(data, 'labs.navigation.viewProjectMenuCompact', false)
            }

            // result.ftue.watchedVideos = _.get(data, 'ftue.watchedVideos', []);
        }

        return result
    }


    static fix_v421(config:any) {

        // patch old skin
        if (config.skin && typeof config.skin === "string") {
            const skinParts = config.skin.split("-");
            const contrast = skinParts[0];
            const fontSize = skinParts[1];
            const configSkin = {
                'lightPalette'  : (contrast==='contrast')?'light-3':'light-1',
                'fontSize'      : (fontSize==='small')?'small':'default',
                'layout'        : config.layout
            }
            config.skin = configSkin
        }
        if (!config.skin) config.skin = {}
        //

        // boardViewBG
        if (_.get(config,'theme.boardViewBg')) {
            if (!config.views) config.views = {}
            if (!config.views.board) config.views.board = {}
            config.views.board.bg = _.get(config,'theme.boardViewBg')
        }
        //

        // fix theme
        if (_.get(config,'theme')) {
            if (_.get(config,'theme.menu')) config.skin.menu = _.get(config,'theme.menu')
            if (_.get(config,'theme.navigation')) config.skin.navigation = _.get(config,'theme.navigation')
        }

        return config;



    }

}
